import { createSelector } from 'reselect';

export const enabledFlagOptionsSelector = createSelector(
  state => state.administration.businessUnitSettings.enabledFlagValues,
  enabledFlagValues => enabledFlagValues.map(({ name, value }) => ({ label: name, value }))
);

export const businessCodeOptionsSelector = createSelector(
  state => state.administration.businessUnitSettings.businessCodes,
  businessCodes => businessCodes.map(({
    businessCode,
    businessDescription,
  }) => ({
    label: businessCode,
    value: businessCode,
    businessDescription,
  }))
);

export const businessUnitsOptionsSelector = createSelector(
  state => state.administration.businessUnitSettings.businessUnits,
  businessCodes => businessCodes.map(({
    businessUnit,
    businessCode,
    businessDescription,
  }) => ({
    label: businessUnit,
    value: businessUnit,
    businessDescription,
    businessCode,
  }))
);

export const isLoadingInitialDataForBusinessUnitModalSelector = state =>
  state.administration.businessUnitSettings.isLoadingInitialDataForBusinessUnitModal;

export const isSavingBusinessInProgressSelector = state =>
  state.administration.businessUnitSettings.isSavingBusinessInProgress;
